import { useEffect } from "react";

export default function useNavbarScroll() {
  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const onScroll = () => {
      navbar.classList.toggle("scrolled", window.scrollY > 60);
    };

    window.addEventListener("scroll", onScroll);
  }, []);
}